/**
 * Контактные и юридические сведения AiSearch.
 *
 * Отдельным модулем, а не текстом в разметке: реквизиты обязаны совпадать
 * во всех местах, где мы их называем (страница контактов, оферта, чек
 * платёжного провайдера). Разойдутся — и расхождение заметит не наш
 * редактор, а проверяющий или банк.
 *
 * Сняты с работающего сервиса aisearch.ru/contacts дословно, включая
 * написание названия организации заглавными буквами: так оно значится в
 * реестре, и «причесать» его нельзя.
 */

/** Реквизиты организации, от лица которой работает сервис. */
export const AIS_RU_REKVIZITY = {
  organizaciya: 'ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ ФРОЛОВ ВАЛЕРИЙ НИКОЛАЕВИЧ',
  inn: '502980825501',
  ogrn: '323508100278546',
} as const;

/** Бот поддержки в Telegram: сюда пишут с вопросом, канал только читают. */
export const AIS_RU_TELEGRAM_BOT = {
  href: 'https://t.me/aisearch_tech_help_bot',
  label: '@aisearch_tech_help_bot',
} as const;

/** Канал в Telegram: второй способ связи, кроме почты. */
export const AIS_RU_TELEGRAM = {
  href: 'https://t.me/aisearch_ru',
  label: '@aisearch_ru',
} as const;
